// MyListingsGrid.jsx
// Grid component for displaying user's listings with actions

import React from 'react';
import ListingCard from '../../components/ListingCard';
import ListingActions from './ListingActions';
import { styles } from './styles';

const MyListingsGrid = ({ 
  listings, 
  onEdit, 
  onDelete, 
  onMarkSold, 
  onViewDetails, 
  onContactBuyer, 
  onArchive 
}) => {
  return (
    <div style={styles.listingsGrid}>
      {listings.map((listing) => (
        <div key={listing.id} style={styles.listingContainer}>
          <ListingCard listing={listing} />
          <ListingActions
            listingId={listing.id}
            listing={listing}
            onEdit={onEdit}
            onDelete={onDelete}
            onMarkSold={onMarkSold}
            onViewDetails={onViewDetails}
            onContactBuyer={onContactBuyer}
            onArchive={onArchive}
          />
        </div>
      ))}
    </div>
  );
};

export default MyListingsGrid;